export const TASK_TYPE = {
  RAT: 'RAT',
  INSECT: 'INSECT',
  DISINFECTION: 'DISINFECTION',
  OTHER_PESTS: 'OTHER_PESTS',
  ANNEX1: 'ANNEX_1',
  ANNEX2: 'ANNEX_2',
  SENTRITECH: 'SENTRITECH',
};

export const tryParseTaskType = v => {
  switch (v.toUpperCase()) {
    case 'RAT':
      return TASK_TYPE.RAT;
    case 'INSECT':
      return TASK_TYPE.INSECT;
    case 'DISINFECTION':
      return TASK_TYPE.DISINFECTION;
    case 'OTHER_PESTS':
      return TASK_TYPE.OTHER_PESTS;
    case 'ANNEX_1':
      return TASK_TYPE.ANNEX1;
    case 'ANNEX_2':
      return TASK_TYPE.ANNEX2;
    case 'SENTRITECH':
      return TASK_TYPE.SENTRITECH;
    default:
      return null;
  }
};



// WEBPACK FOOTER //
// ./src/modules/saas/constants/index.js